<template>
  <b-dropdown
    id="actions-dropdown"
    :disabled="disabled"
    toggle-tag="div"
    toggle-class="p-0 bg-transparent"
    hide-on-click-out
    @hide="onDropdownHide"
  >
    <template #button-content>
      <McButton
        v-bind="buttonProps"
        variant="secondary"
        icon="icon-outline_chevron-down"
        icon-position="right"
        :text="$t('global.field.action')"
        :disabled="disabled"
      />
    </template>

    <b-dropdown-item
      v-if="hasFinancialInvoicing && integratedProvider === 'ACCURATE'"
      @click="actionHandlers.handleCreateBill"
    >
      <div class="d-flex justify-content-between">
        <div class="me-4">
          {{ $t('delivery.action.billDelivery') }}
        </div>
        <img
          class="icon-provider"
          :src="require('@/assets/images/setting/integration/accurate.png')"
        />
      </div>
    </b-dropdown-item>
    <b-dropdown-item @click="handleAction(actionHandlers.handleDuplicate)">
      {{ $t('global.duplicate') }}
    </b-dropdown-item>
    <b-dropdown-item
      v-if="hasFeatureCreateFoFromDoMGM"
      class="multilevel-dropdown"
      @click="handleAction(() => {}, false)"
    >
      <div class="d-flex justify-content-between align-items-center">
        <span>{{ $t('delivery.action.scheduleFleetTask') }}</span>
        <i class="icon-outline_chevron-right"></i>
      </div>
      <div class="gap-filler"></div>
      <div class="multilevel-dropdown-menu pr-2">
        <div class="dropdown-menu">
          <b-dropdown-item @click="handleAction(actionHandlers.handleCreateFoDirect)">
            Direct
            <i
              id="tooltip-direct"
              class="mc-fa icon-outline_info"
              style="position: relative; bottom: -2px; font-size: 16px"
            >
            </i>
            <b-tooltip target="tooltip-direct" triggers="hover" placement="rightbottom">
              {{ $t('delivery.message.shipmentDirectToFinalDestination') }}
            </b-tooltip>
          </b-dropdown-item>
          <b-dropdown-item @click="handleAction(actionHandlers.handleCreateFoTransit)">
            Transit
            <i
              id="tooltip-transit"
              class="mc-fa icon-outline_info"
              style="position: relative; bottom: -2px; font-size: 16px"
            >
            </i>
            <b-tooltip target="tooltip-transit" triggers="hover" placement="rightbottom">
              {{ $t('delivery.message.multipleFleetTasksWithTransit') }}
            </b-tooltip>
          </b-dropdown-item>
        </div>
      </div>
    </b-dropdown-item>
    <b-dropdown-item
      v-if="!isTmsMarketing || hasTmsMarketingFlag"
      class="multilevel-dropdown"
      @click="handleAction(() => {}, false)"
    >
      <div class="d-flex justify-content-between align-items-center">
        <span>{{ $t('delivery.action.changeStatus')}}</span> <i class="icon-outline_chevron-right"></i>
      </div>
      <!-- Invisible box to fill gap between dropdown and child dropdown. If this doesn't exist, the child dropdown disappear when user
       move their cursor to child dropdown -->
      <div class="gap-filler"></div>
      <div class="multilevel-dropdown-menu pr-2">
        <div class="dropdown-menu">
          <b-dropdown-item
            v-if="!hasTmsMarketingFlag && hasVmsScope"
            @click="handleAction(actionHandlers.handleTransitionToWaitingVendor)"
          >
            {{ $t('delivery.action.sendRequestToVendor') }}
          </b-dropdown-item>
          <b-dropdown-item @click="handleAction(actionHandlers.handleTransitionToConfirmed)">
            {{ $t('delivery.status.confirmed') }}
          </b-dropdown-item>
          <b-dropdown-item
            v-if="!hasTmsMarketingFlag"
            @click="handleAction(actionHandlers.handleTransitionToRescheduled)"
          >
            {{ $t('delivery.status.rescheduled') }}
          </b-dropdown-item>
          <b-dropdown-item
            v-if="!hasTmsMarketingFlag"
            class="text-red"
            @click="handleAction(actionHandlers.handleTransitionToCanceled)"
          >
            {{ $t('delivery.status.canceled') }}
          </b-dropdown-item>
        </div>
      </div>
    </b-dropdown-item>
    <b-dropdown-item
      v-if="hasBulkUpdateUserGroup && !isTmsMarketing"
      @click="handleAction(actionHandlers.handleUpdateUserGroup)"
    >
      {{ $t('delivery.action.selectUserGroup') }}
    </b-dropdown-item>
    <b-dropdown-item class="text-red" @click="handleAction(actionHandlers.handleDelete)">
      {{ $t('global.delete') }}
    </b-dropdown-item>
  </b-dropdown>
</template>

<script>
import McButton from '@/components/McButton'
import { mapGetters } from 'vuex'
import { Helper } from '@/mixin/helper'
import { isTmsMarketingUser } from '@/helpers/tms-access'

export default {
  components: {
    McButton,
  },
  mixins: [Helper],
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    actionHandlers: {
      type: Object,
    },
    integratedProvider: {
      type: String,
    },
    hasFeatureCreateFoFromDoMGM: {
      type: Boolean,
      default: false,
    },
    buttonProps: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      okToHide: true,
    }
  },
  computed: {
    ...mapGetters({
      hasAccessAll: 'identity/hasAccessAll',
      getFeatureFlagValue: 'identity/getFeatureFlagValue',
    }),
    hasVmsScope() {
      return this.hasAccessAll(['vms:create', 'vms:delete', 'vms:read', 'vms:update'])
    },
    hasFinancialInvoicing() {
      return this.hasAccessAll([
        'financial-invoicing-integration-accurate:create',
        'financial-invoicing-integration-accurate:delete',
        'financial-invoicing-integration-accurate:read',
        'financial-invoicing-integration-accurate:update',
      ])
    },
    hasBulkUpdateUserGroup() {
      return (
        this.hasAccessAll([
          'tms-user-group:create',
          'tms-user-group:delete',
          'tms-user-group:read',
          'tms-user-group:update',
        ]) && this.isSuperUser()
      )
    },
    isTmsMarketing() {
      return isTmsMarketingUser()
    },
    hasTmsMarketingFlag() {
      return this.isTmsMarketing
    },
  },
  methods: {
    handleAction(handler, shouldClose = true) {
      handler()
      if (!shouldClose) {
        this.okToHide = false
      }
    },
    onDropdownHide(bvEvent) {
      if (!this.okToHide) {
        bvEvent.preventDefault()
        this.okToHide = true
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import './style.scss';
</style>
